import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { prettify } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { Building2 } from "lucide-react";

const ROWS = [
  ["company", "Company"], ["category", "Category"], ["contact_name", "Contact"],
  ["phone", "Phone"], ["email", "Email"], ["address", "Address"],
  ["city", "City"], ["state", "State"], ["service_area", "Service Area"], ["status", "Status"],
];

export default function PartnerProfile() {
  const [p, setP] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/portal/profile"); setP(data); }
      finally { setLoading(false); }
    })();
  }, []);

  if (loading) return <Skeleton className="h-64" />;

  return (
    <div>
      <h2 className="font-display text-2xl font-bold text-[#252221] mb-1">Profile</h2>
      <p className="text-sm text-muted-foreground mb-5">Your partner details on file with MovingMyMama.</p>
      <Card className="p-6 border-[#E6EDF2]" style={{ boxShadow: "var(--mmm-shadow-sm)" }} data-testid="partner-profile-card">
        <div className="flex items-center gap-3 mb-5">
          <div className="h-12 w-12 rounded-xl flex items-center justify-center" style={{ backgroundColor: "rgba(28,67,88,0.10)" }}><Building2 size={22} className="text-[#1C4358]" /></div>
          <div className="font-display text-xl font-bold text-[#252221]">{p?.name || "—"}</div>
        </div>
        <dl className="divide-y divide-[#F0F4F7]">
          {ROWS.map(([k, label]) => (
            <div key={k} className="grid grid-cols-3 gap-3 py-2.5">
              <dt className="text-[13px] text-muted-foreground">{label}</dt>
              <dd className="text-sm text-[#252221] col-span-2">{p?.[k] ? (k === "category" || k === "status" ? prettify(p[k]) : p[k]) : "—"}</dd>
            </div>
          ))}
        </dl>
      </Card>
    </div>
  );
}
